import {
  CREATE_EID_FORM,
  CREATE_VIRAL_LOAD_FORM,
  FETCH_EID_APPROVED_SAMPLE,
  FETCH_EID_COLLECTED_SAMPLE,
  FETCH_EID_ORDERED_SAMPLE,
  FETCH_EID_SAMPLE,
  FETCH_EID_SAMPLES,
  FETCH_VIRAL_LOAD_APPROVED_SAMPLE,
  FETCH_VIRAL_LOAD_COLLECTED_SAMPLE,
  FETCH_VIRAL_LOAD_ORDERED_SAMPLE,
  FETCH_VIRAL_lOAD_SAMPLE,
  FETCH_VIRAL_lOAD_SAMPLES,
} from "constants/ActionTypes";

const VR_INITIAL_STATE = {
  data: [],
  loading: false,
  viralLoadList: [],
  viralLoadOrderedList: [],
  viralLoadCollectedList: [],
  viralLoadApprovedList: [],
  viralLoad: null,
};

const EID_INITIAL_STATE = {
  data: [],
  loading: false,
  EIDList: [],
  eidOrderedList: [],
  eidCollectedList: [],
  eidApprovedList: [],
  EID: null,
};

export const ViralLoadFormReducer = (state = VR_INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_VIRAL_LOAD_FORM: {
      let updatedForm = state;
      updatedForm = [action.payload, ...updatedForm];

      return {
        ...state,
        state: updatedForm,
      };
    }
    case FETCH_VIRAL_lOAD_SAMPLES: {
      return {
        ...state,
        viralLoadList: action.payload,
      };
    }
    case FETCH_VIRAL_LOAD_ORDERED_SAMPLE: {
      return {
        ...state,
        viralLoadOrderedList: action.payload,
      };
    }
    case FETCH_VIRAL_LOAD_COLLECTED_SAMPLE: {
      return {
        ...state,
        viralLoadCollectedList: action.payload,
      };
    }
    case FETCH_VIRAL_LOAD_APPROVED_SAMPLE: {
      return {
        ...state,
        viralLoadApprovedList: action.payload,
      };
    }
    case FETCH_VIRAL_lOAD_SAMPLE: {
      return {
        ...state,
        viralLoad: action.payload,
      };
    }
    default:
      return state;
  }
};

export const EIDFormReducer = (state = EID_INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_EID_FORM: {
      let updatedForm = state;
      updatedForm = [action.payload, ...updatedForm];

      return {
        ...state,
        state: updatedForm,
      };
    }
    case FETCH_EID_SAMPLES: {
      return {
        ...state,
        EIDList: action.payload,
      };
    }
    case FETCH_EID_ORDERED_SAMPLE: {
      return {
        ...state,
        eidOrderedList: action.payload,
      };
    }
    case FETCH_EID_SAMPLE: {
      return {
        ...state,
        EID: action.payload,
      };
    }
    case FETCH_EID_COLLECTED_SAMPLE: {
      return {
        ...state,
        eidCollectedList: action.payload,
      };
    }
    case FETCH_EID_APPROVED_SAMPLE: {
      return {
        ...state,
        eidApprovedList: action.payload,
      };
    }
    default:
      return state;
  }
};
